import { SpeedDial, SpeedDialIcon } from '@mui/material';
import { Box } from '@mui/system';
import React, { useState } from 'react';
import RepositoriesTable from '../../../../components/administrative/repositories/repositoriesTable/repositoriesTable';
import RepositoryDialog from '../../../../components/administrative/repositories/repositoryDialog/repositoryDialog';

const RepositoriesPage = () => {
  const [values, setValues] = useState({});
  const [open, setOpen] = useState(false);
  const [changed, setChanged] = useState(false);

  const handleChanged = () => {
    setChanged(!changed);
  }

  const handleNewRepository = () => {
    setValues({});
    setOpen(true);
  }

  return (
    <div style={{padding: 20}}>
      <Box>
        <RepositoryDialog
          open={open}
          setOpen={setOpen}
          values={values}
          setValues={setValues}
          changed={changed}
          handleChanged={handleChanged}
        />
      </Box>
      <div>
        <SpeedDial
          ariaLabel="Novo repositório"
          sx={{ position: 'fixed', bottom: 120, right: 16 }}
          icon={<SpeedDialIcon />}
          onClick={() => handleNewRepository()}
        >
        </SpeedDial>
      </div>
      <RepositoriesTable
        changed={changed}
        handleChanged={handleChanged}
      />
    </div>
  )
}

export default RepositoriesPage;
